import { BlogSection } from '@/types/blog';

export const buch_empfehlung: BlogSection = {
  id: 'buch-empfehlung',
  title: 'Die zwei Bücher (Empfehlung)',
  content: `
    <div class="grid md:grid-cols-2 gap-8 my-10">
      <div class="bg-gradient-to-br from-joerg-50 to-primary/10 dark:from-joerg-900 dark:to-primary/20 p-8 rounded-2xl border border-joerg-200 dark:border-joerg-700">
        <h3 class="text-2xl font-bold text-joerg-800 dark:text-joerg-100 mb-4">1. „Haben oder Sein" (1976)</h3>
        
        <p class="text-joerg-700 dark:text-joerg-300 mb-4"><strong>Worum es geht:</strong></p>
        <p class="text-joerg-700 dark:text-joerg-300 mb-6">Fromm analysiert die westliche Konsumgesellschaft und zeigt: Wir sind im Haben-Modus gefangen. Alles wird zur Ware – auch Beziehungen, auch Wissen, auch Glück.</p>

        <p class="text-joerg-700 dark:text-joerg-300 mb-4"><strong>Warum relevant:</strong></p>
        <ul class="space-y-2 text-joerg-700 dark:text-joerg-300 text-sm mb-6">
          <li>• <strong>Für Unternehmer:</strong> Existierst du, um zu haben (Umsatz, Status, Follower)? Oder um zu sein (Wirkung, Resonanz, Tiefe)?</li>
          <li>• <strong>Für Beziehungen:</strong> Hast du einen Partner? Oder praktizierst du Liebe?</li>
        </ul>

        <div class="bg-white/50 dark:bg-joerg-800/50 p-4 rounded-lg border border-joerg-200 dark:border-joerg-600">
          <p class="text-joerg-600 dark:text-joerg-300 text-sm italic">„Im Haben-Modus ist mein Bezug zur Welt ein Bezug des Besitzergreifens und Besitzens, ein Bezug, in dem ich alles und jeden, mich selbst eingeschlossen, zu meinem Besitz machen will."</p>
        </div>
      </div>

      <div class="bg-gradient-to-br from-sage-50 to-joerg-50 dark:from-sage-900 dark:to-joerg-900 p-8 rounded-2xl border border-sage-200 dark:border-sage-800">
        <h3 class="text-2xl font-bold text-joerg-800 dark:text-joerg-100 mb-4">2. „Die Kunst des Liebens" (1956)</h3>
        
        <p class="text-joerg-700 dark:text-joerg-300 mb-4"><strong>Worum es geht:</strong></p>
        <p class="text-joerg-700 dark:text-joerg-300 mb-6">Liebe ist keine Emotion, die über uns kommt. Liebe ist eine Kunst – und wie jede Kunst erfordert sie Theorie und Praxis.</p>

        <p class="text-joerg-700 dark:text-joerg-300 mb-4"><strong>Warum relevant:</strong></p>
        <ul class="space-y-2 text-joerg-700 dark:text-joerg-300 text-sm mb-6">
          <li>• <strong>Für Beziehungen:</strong> Liebe ist nicht „Ich fühle", sondern „Ich praktiziere."</li>
          <li>• <strong>Für Business:</strong> Beziehungen zu Kunden, Mitarbeitern, Partnern – alles folgt denselben Prinzipien.</li>
        </ul>

        <div class="bg-white/50 dark:bg-joerg-800/50 p-4 rounded-lg border border-joerg-200 dark:border-joerg-600">
          <p class="text-joerg-600 dark:text-joerg-300 text-sm italic">„Lieben ist eine Tätigkeit, keine passive Affektion; es ist ein 'Stehen in', nicht ein 'Fallen für'."</p>
        </div>
      </div>
    </div>

    <div class="bg-gradient-to-r from-green-50 to-blue-50 dark:from-green-900/30 dark:to-blue-900/30 border border-green-200 dark:border-green-700 p-8 rounded-2xl my-10">
      <h4 class="text-xl font-bold text-joerg-800 dark:text-joerg-100 mb-6 text-center">🏪 Support Your Local Dealer</h4>
      
      <p class="text-joerg-700 dark:text-joerg-300 mb-6 text-center">Ich empfehle Ihnen, die Bücher bei Ihrem lokalen Buchhändler zu erwerben. Als Beispiel hier die Links zu Genniges Bücher, meinem lokalen Buchhändler:</p>
      
      <div class="space-y-4">
        <div class="bg-white dark:bg-joerg-800 border border-joerg-200 dark:border-joerg-600 p-6 rounded-lg">
          <div class="text-center mb-4">
            <h5 class="font-semibold text-joerg-800 dark:text-joerg-100 mb-2">Erich Fromm: Haben oder Sein</h5>
            <p class="text-sm text-joerg-600 dark:text-joerg-400 mb-4">Taschenbuch • dtv Verlag</p>
          </div>
          
          <div class="text-center">
            <a href="https://genniges-buecher.buchhandlung.de/shop/article/3622360/erich_fromm_haben_oder_sein.html" 
               target="_blank" 
               rel="noopener noreferrer" 
               class="inline-block bg-joerg-800 dark:bg-joerg-100 text-white dark:text-joerg-900 px-8 py-4 rounded-lg font-bold text-lg hover:bg-joerg-700 dark:hover:bg-joerg-200 transition-all duration-200 shadow-lg hover:shadow-xl border-2 border-joerg-800 dark:border-joerg-100">
              Bei Genniges Bücher bestellen
            </a>
          </div>
        </div>

        <div class="bg-white dark:bg-joerg-800 border border-joerg-200 dark:border-joerg-600 p-6 rounded-lg">
          <div class="text-center mb-4">
            <h5 class="font-semibold text-joerg-800 dark:text-joerg-100 mb-2">Erich Fromm: Die Kunst des Liebens</h5>
            <p class="text-sm text-joerg-600 dark:text-joerg-400 mb-4">Großdruck • Suhrkamp Verlag</p>
          </div>
          
          <div class="text-center">
            <a href="https://genniges-buecher.buchhandlung.de/shop/article/1310557/erich_fromm_die_kunst_des_liebens_grossdruck.html" 
               target="_blank" 
               rel="noopener noreferrer" 
               class="inline-block bg-joerg-800 dark:bg-joerg-100 text-white dark:text-joerg-900 px-8 py-4 rounded-lg font-bold text-lg hover:bg-joerg-700 dark:hover:bg-joerg-200 transition-all duration-200 shadow-lg hover:shadow-xl border-2 border-joerg-800 dark:border-joerg-100">
              Bei Genniges Bücher bestellen
            </a>
          </div>
        </div>
      </div>

      <p class="text-xs text-joerg-500 dark:text-joerg-400 mt-6 text-center">* Falls diese Links nicht mehr aktiv sein sollten, suchen Sie einfach nach den Titeln bei Ihrem lokalen Buchhändler.</p>
    </div>

    <div class="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-700 p-6 rounded-lg my-8">
      <h4 class="font-semibold text-blue-800 dark:text-blue-100 mb-3">🧠 Neurowissenschaftlich betrachtet: Warum lokale Unterstützung Vertrauen schafft</h4>
      <p class="text-blue-700 dark:text-blue-300 mb-4">Unser Gehirn ist darauf programmiert, <strong>Authentizität und Integrität</strong> zu erkennen. Wenn ich Ihnen einen lokalen Buchhändler empfehle, anstatt einen Affiliate-Link zu verwenden, sendet das unbewusste Signale:</p>
      
      <ul class="space-y-2 text-blue-700 dark:text-blue-300 text-sm">
        <li>• <strong>Keine versteckten Gewinnabsichten</strong> – meine Empfehlung ist genuiner Natur</li>
        <li>• <strong>Gemeinschaftsorientierung</strong> – ich denke über den eigenen Vorteil hinaus</li>
        <li>• <strong>Langfristige Perspektive</strong> – lokale Strukturen sind nachhaltig und vertrauenswürdig</li>
        <li>• <strong>Konsistenz</strong> – meine Werte spiegeln sich in meinen Handlungen wider</li>
      </ul>
      
      <p class="text-blue-600 dark:text-blue-400 text-sm mt-4 italic">Diese unbewusste Vertrauensbildung ist der Grund, warum ich bewusst auf Affiliate-Marketing verzichte und stattdessen echte, wertorientierte Empfehlungen ausspreche.</p>
    </div>
  `
};
